module.exports = __webpack_public_path__ + "img/settings.5e7f7aae.svg";